<template>
  <nav class="d-flex flex-sb w-100p adm_nav">
    <section class="d-flex">
      <img src="@/assets/img/Logo-w.svg" class="nav_logo">
      <div class="d-flex nav_search">
        <img src="@/assets/img/nav-search.svg" class="nav_sch_i">
        <input type="text" placeholder="Search">
      </div>
    </section>

    <section class="d-flex al-cnt">
      <div class="nav_btns">
        <!--확인하지 않은 알림이 있는 경우 has-update 추가-->
        <button class="has-update">
          <img src="@/assets/img/notif-w.svg">
          <i :style="[mlevel>=10?{'background-color': '#098eff'}:'']"></i>
        </button>
        <button>
          <img src="@/assets/img/message-w.svg">
          <i></i>
        </button>
        <button type="button" @click="goLink('/config')">
          <img src="@/assets/img/option-w.svg">
          <i></i>
        </button>
      </div>
      <router-link to="/login" class="nav_signIn" :style="[mlevel>=10?{'background-color': '#098eff'}:'']" v-if=" loginCheck === true " @click="signOut">
        <img src="@/assets/img/right-enter.svg"> SIGN OUT
      </router-link>
    </section>
  </nav>
</template>

<script>
import store from "@/store";

export default {
  name: "ManagerComponent",
  components: {},
  data() {
    return {
      loginCheck: ( store.state.myInfo.idxMember > 0 ) ? true : false,
      mlevel: store.state.myInfo.mlevel,
    };
  },
  methods: {
    goLink(link){
      this.$router.push(link);
    },
    signOut(){
      localStorage.removeItem('authorization');
      this.loginCheck = false;
      this.$router.push('/');
    },
  },
}
</script>
